import { render } from "./SeoSeaView.vue?vue&type=template&id=08384358&scoped=true"
import script from "./SeoSeaView.vue?vue&type=script&lang=js"
export * from "./SeoSeaView.vue?vue&type=script&lang=js"

import "./SeoSeaView.vue?vue&type=style&index=0&id=08384358&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08384358"]])

export default __exports__